module.exports = __webpack_public_path__ + "img/paracord2.39d0b628.jpg";